import { CloseOutlined } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';

interface FileUploadModalHeaderProps {
  headerText: string;
  onCloseDialog: () => void;
}

export const FileUploadModalHeader = ({
  headerText,
  onCloseDialog,
}: FileUploadModalHeaderProps) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="h6">{headerText}</Typography>
      <IconButton
        aria-label="close"
        onClick={onCloseDialog}
        sx={{ top: -2, right: -8 }}
      >
        <CloseOutlined />
      </IconButton>
    </Stack>
  );
};
